import { createContext } from 'react';

const messageContext = createContext(null);

export default messageContext;
